var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes, on: { click: _vm.onClick } }, [
    _c("div", { staticClass: "trbo-a-question-progress-bar-item__dot" }),
    _vm._v(" "),
    _c("button", { staticClass: "trbo-a-question-progress-bar-item__label" }, [
      _vm._v("\n    " + _vm._s(_vm.wizardPage.title) + "\n  "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }